import React, { FC } from 'react';
import { withApplicationLayout } from 'hocs/withApplicationLayout';
import { withAuth } from 'hocs/withAuth/withAuth';

const P: FC = ({ children }) => <p style={{ padding: '2rem' }}>{children}</p>;

export function withComputeEnabled<P extends Record<string, unknown> = Record<string, unknown>>() {
  return (Component: FC<P>): FC<P> => {
    // Combine the HOCs in the correct order
    return withApplicationLayout<P>()(
      withAuth<P>({
        hideFor: 'GUEST',
        placeholder: <P>You must be logged in to access compute.</P>,
      })(Component),
    );
  };
}
